import { DefaultErrorPage } from '@odmonorepo/core-components';
import OffersExpiredError from './OffersExpiredError';
import ApplicationExpiredError from './ApplicationExpiredError';
import { AppError } from 'merchant-api';
import { useAnalytics } from 'use-analytics';
import { ErrorComponentProps } from '@tanstack/react-router';
import NoOfferError from './NoOfferError';
import NewUser from './NewUser';
import MaintenancePage from './MaintenancePage';
import CustomLinkRequired from './CustomLinkRequired';
import { useRef, useEffect } from 'react';
import { AppLayout, CheckoutLayout, LoginLayout, LoginServer, SalesAlertError } from 'merchant-components';
import LogoOnlyHeader from '../../Layout/Components/Header/LogoOnlyHeader';
import { AxiosError } from 'axios';

export const errorWithLayout = (error) => <AppLayout header={<LogoOnlyHeader />} outlet={error} />;

export const ErrorPage = (props: ErrorComponentProps) => {
  const analytics = useAnalytics();
  const trackedRef = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (props.error && trackedRef.current !== props.error?.message) {
      analytics.track('DetailedError', {
        error: props.error,
        ComponentStack: props.info?.componentStack,
      });
      trackedRef.current = props.error?.message;
    }
  }, [props.error, props.info, analytics]);

  if (props.error instanceof AppError && props.error.name === 'Unauthenticated') {
    return <LoginLayout outlet={<LoginServer redirect={window.location.pathname + window.location.search} />} />;
  }

  const errorMsg = ((props?.error as AxiosError)?.response?.data as any)?.message;
  if (errorMsg?.includes('Missing business tax id')) {
    return <SalesAlertError error={AppError.MissingTaxId} />;
  }

  if (props.error instanceof AppError && props.error.salesAgentAction != null) {
    return <SalesAlertError error={props.error} />;
  }

  if (props.error instanceof AppError) {
    switch (props.error.name) {
      case 'NoOffer':
        return errorWithLayout(<NoOfferError />);
      case 'OffersExpired':
        return errorWithLayout(<OffersExpiredError />);
      case 'ApplicationExpired':
        return errorWithLayout(<ApplicationExpiredError />);
      case 'NewUser':
        return errorWithLayout(<NewUser />);
      case 'Maintenance':
        return <MaintenancePage />;
      case 'CustomLinkRequired':
        return <CheckoutLayout outlet={<CustomLinkRequired />} />;
      default:
        return <DefaultErrorPage />;
    }
  }

  return <DefaultErrorPage />;
};
export default ErrorPage;
